import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=29dd0ac6&scoped=true&"
import script from "./certificate.vue?vue&type=script&lang=js&"
export * from "./certificate.vue?vue&type=script&lang=js&"
import style0 from "./certificate.vue?vue&type=style&index=0&id=29dd0ac6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd0ac6",
  null
  
)

export default component.exports